import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {  INITIAL_TOKEN, API_URL, API_URL_NURSE } from "../../config/config";
import { getToken } from "./localStorageService";

export const baseApiForAuth = createApi({
  reducerPath: "baseApiForAuth",
  baseQuery: fetchBaseQuery({
    baseUrl: API_URL,
    prepareHeaders: (headers, { getState }) => {
      headers.set("token", INITIAL_TOKEN);
        let auth_token = getToken();
        if (auth_token) {
          headers.set("authorization", `Bearer ${auth_token}`);
        }
      return headers;
    },
  }),
  endpoints: () => ({}),
});

export const baseApiForNurse = createApi({
  reducerPath: "baseApiForNurse",
  baseQuery: fetchBaseQuery({
    baseUrl: API_URL_NURSE,
    prepareHeaders: (headers, { getState }) => {
      headers.set("token", INITIAL_TOKEN);
        let auth_token = getToken();
        if (auth_token) {
          headers.set("authorization", `Bearer ${auth_token}`);
        }
      return headers;
    },
  }),
  endpoints: () => ({}),
});
